import { Task } from 'taskarian';
import { callApi } from '../../../../Appy';
import { findLinkT } from '../../../../LinkyLinky';
import { Link } from '../../../../Resource/Types';
import { fromNullableT } from '../../../../TaskExt';
import { learningCollectionNewFormResourceDecoder } from '../Decoders';
import LearningCollectionStore from '../Store';
import { LearningCollectionError, LearningCollectionNewFormResource } from '../Types';

const loadNewCollectionResource = (links: ReadonlyArray<Link>) =>
  Task.succeed<LearningCollectionError, ReadonlyArray<Link>>(links)
    .andThen(findLinkT('new-learning-collection'))
    .andThen(callApi(learningCollectionNewFormResourceDecoder, {}));

const loadNewTemplate = (args: { resource: LearningCollectionNewFormResource }) =>
  fromNullableT(args.resource.templates.self);

const loadForNew = (links: ReadonlyArray<Link>, store: LearningCollectionStore) =>
  Task.succeed<LearningCollectionError, {}>({})
    .assign('resource', loadNewCollectionResource(links))
    .assign('template', loadNewTemplate)
    .fork(store.loadError, store.ready);

export default loadForNew;
